/// <reference path="../../../scripts/typings/Nema.Crew.Model.d.ts" />

import coreConstants = require("./core.constants");
import { Injectable, Inject } from '@angular/core';

export function initialize(module: ng.IModule) {
    module.service(SearchService.Id, SearchService);

    SearchService.$inject = ["$http"];
}

@Injectable()
export class SearchService implements ISearchService {

    private $http: ng.IHttpService;
    private searchCompetencesServiceUrl = coreConstants.ServiceConfig.webApiUrl + "CompetencesQueryService/SearchPersonCompetencesPost/";
    private searchActivitiesServiceUrl = coreConstants.ServiceConfig.webApiUrl + "ActivitiesQueryService/SearchActivitiesPost/";
    private sumActivitiesServiceUrl = coreConstants.ServiceConfig.webApiUrl + "ActivitiesQueryService/SumActivitiesPost/";

    constructor( @Inject("$http") $http: ng.IHttpService) {
        this.$http = $http;
    }

    public static Id = "searchService";

    public searchPersonCompetences(personCompetenceQuery: PersonCompetenceQuery): ng.IPromise<Nema.Crew.Model.PersonWithRelevantCompetences[]> {
        return this.$http
            .post(this.searchCompetencesServiceUrl, JSON.stringify(personCompetenceQuery))
            .then(res => <Nema.Crew.Model.PersonWithRelevantCompetences[]>res.data);
    }

    public activitiesSum(sumActivitiesQuery: SumActivitiesQuery): ng.IPromise<Nema.Crew.Model.ActivitySummationSummationResult> {
        return this.$http
            .post(this.sumActivitiesServiceUrl, JSON.stringify(sumActivitiesQuery))
            .then(res => <Nema.Crew.Model.ActivitySummationSummationResult>res.data);
    }

    public searchActivities(searchActivitiesQuery: SearchActivitiesQuery): ng.IPromise<Nema.Crew.Model.ActivitySearchResult[]> {
        return this.$http
            .post(this.searchActivitiesServiceUrl, JSON.stringify(searchActivitiesQuery))
            .then(res => <Nema.Crew.Model.ActivitySearchResult[]>res.data);
    }
}

export interface ISearchService {
    searchPersonCompetences(personCompetenceQuery: PersonCompetenceQuery): ng.IPromise<Nema.Crew.Model.PersonWithRelevantCompetences[]>;

    activitiesSum(activitySumQuery: SumActivitiesQuery): ng.IPromise<Nema.Crew.Model.ActivitySummationSummationResult>;

    searchActivities(searchActivitiesQuery: SearchActivitiesQuery): ng.IPromise<Nema.Crew.Model.ActivitySearchResult[]>;
}

export interface PersonCompetenceQuery {
    PersonIds: number[];

    CompetenceIds: number[];

    IncludeExpired?: boolean;

    IncludeFuture?: boolean;

    IncludeInactive?: boolean;

    Date: Date;
}

export interface SearchActivitiesQuery {
    From: Date;

    To: Date;

    PersonIds: number[];

    WorkplaceIds: number[];

    ActivityTypeIds: number[];

    JobTitleIds: number[];

    Skip?: number;

    Take?: number;
}

export interface SumActivitiesQuery {
    From: Date;

    To: Date;

    SummationGroupIds: number[];

    PersonIds: number[];
}


// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/@angularclass/hmr-loader!./node_modules/tslint-loader!./client/app/core/search.dataservice.ts